import React, { useState } from 'react';
import { MdDelete } from 'react-icons/md'
import { BiEdit } from 'react-icons/bi'
import TodoForm from './TodoForm';

const Todo = ({todos, completeTodo, removeTodo, updateTodo}) => {
    const [edit, setEdit]=useState({
        id:null,
        value:''
    })
    const submitUpdate=value=>{
        updateTodo(edit.id , value)
        setEdit({
            id:null,
            value:''
        })
    }
    if(edit.id){
        return <TodoForm edit={edit} onSubmit={submitUpdate}/>
    }
    return (
        <div className='to-do'>
            {
            todos.map((todo, index)=>(
                <div className={todo.isComplete? 'todo-row complete': 'todo-row'} key={index}>
                    <div key={todo.id} onClick={()=>completeTodo(todo.id)}>
                        {todo.text}
                    </div>
                    <div className="icons">
                        <MdDelete onClick={()=>removeTodo(todo.id)} className='delete-icon'/>
                        <BiEdit onClick={()=>setEdit({id:todo.id, value:todo.text})} className='edit-icon'/>
                    </div>
                </div>
            ))
            }
        </div>
    );
};

export default Todo;